import React, { useEffect, useRef } from "react";

import { toast } from "../Toast";

interface SuccessNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  details: string;
  type?: "success" | "error";
}

const SuccessNotification: React.FC<SuccessNotificationProps> = ({
  isOpen,
  onClose,
  message,
  details,
  type = "success",
}) => {
  const lastShownKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isOpen) {
      lastShownKeyRef.current = null;
      return;
    }

    const notificationKey = `${type}:${message}:${details}`;
    if (lastShownKeyRef.current === notificationKey) {
      return;
    }

    lastShownKeyRef.current = notificationKey;

    const content = {
      title: message,
      message: details,
    };

    if (type === "error") {
      toast.error(content);
    } else {
      toast.success(content);
    }

    onClose();
  }, [details, isOpen, message, onClose, type]);

  return null;
};

export default SuccessNotification;
